import { ModalityLabel } from '@dynamika-shared/types/imagingLabels';

export const searchByName = (
  labels: ModalityLabel[],
  searchTerm: string
): ModalityLabel[] => {
  const lowerCaseSearch = searchTerm.toLowerCase();
  return labels.reduce<ModalityLabel[]>((groupAcc, { modalityName, labels }) => {
    const filteredLabels = labels.filter(el =>
      el.name.toLowerCase().includes(lowerCaseSearch)
    );
    if (filteredLabels.length) {
      groupAcc.push({ labels: filteredLabels, modalityName });
    }
    return groupAcc;
  }, []);
};
